import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {
  selected = 'option2';

  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;

  routeUrl: string;
  visibility = false;
  subscription: any;
  progInfoSubscription: any;
  bottomBarActive: true;

  @Output() headerMenuEvent = new EventEmitter();

  constructor(
    private _formBuilder: FormBuilder,
    public auth:AuthenticationService
    ) {}

  ngOnInit(): void {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
